<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLabel1">Update Approval</h4>
            <button
              type="button"
              @click="close"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <button type="button" class="btn btn-rounded float-right" @click="addApproval">
              <span class="mx-3">Add</span>
            </button>
            <Table
              :items="items"
              :filter="filters"
              :header="headers"
              :forbitDetail="false"
              :forbidBerkas="false"
              :forbidBerkaskan="false"
              :forbidMoveBerkas="false"
              :forbidAtasan="false"
              :forbidEdit="false"
              :forbidKonfirmasi="false"
              :forbidDisposisi="false"
              :forbidDelete="false"
              :draftingFileDetail="draftingFileDetail"
              @close="close"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Table from "@/components/table/tableApproval";
export default {
  components: {
    Table,
  },
  props: ["draftingFileDetail"],
  data() {
    return {
      headers: {
        users_id: {
          label: "Approval Utama",
          sortable: true,
        },
        alt_users_id: {
          label: "Approval Pengganti",
          sortable: true,
        },
        status: {
          label: "Status",
          sortable: true,
        },
      },
    };
  },
  computed: {
    items() {
      const dataApproval = this.draftingFileDetail.signers;
     
      const dataApproval2 = this.draftingFileDetail.approvals;
      //  console.log(dataApproval);
      // console.log(dataApproval2);
      if (!dataApproval) {
        return [];
      }

      const dataMapApproval = dataApproval.map((item, index) => {
        let altUsersName;
      // console.log(item.pivot);

        const altUserFind = dataApproval2.find(
          (id) => id.id == item.pivot.alt_users_id
        );
        if (item.pivot.status == 3) {
          if(altUserFind != null){
            altUsersName = altUserFind.name;
          } else {
            altUsersName = null;
          }
        } else {
          altUsersName = null;
        }

        const data = {
          increment: index + 1,
          id: item.pivot.id,
          users_id: item.name,
          status: item.pivot.status,
          action: item.pivot.action,
          actor: item.pivot.actor,
          alt_users_id: altUsersName,
        };
        console.log(data.status)
        switch (data.status) {
          case '1':
            data.status = "Submited";
            break;
          case '2':
            data.status = "Revisi";
            break;
          case '3':
            data.status = "Approved";
            break;
          case '4':
            data.status = "Rejected";
            break;
          default:
            data.status = "Draft";
            break;
        }

        return data;
      });
      // console.log(dataMapApproval);
      return dataMapApproval;
    },
    filters() {
      return this.$store.state.approval.items.length === 0 ||
        this.$store.state.approval.items.length != undefined
        ? {}
        : this.$store.state.approval.items.filters;
    },
    state() {
      return this.$store.state.approval;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addApproval() {
      this.$emit("addItems");
    },
  },
};
</script>
<style>
.modal-backdrop {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  position: relative !important;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #4aae9b;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>